import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TabBar } from './TabBar';
import { Sidebar } from './Sidebar';
import { DrawerLayout, DrawerContent } from './DrawerLayout';
import { DrawerProvider, useDrawer } from '../../context/DrawerContext';
import { useDrawerMenuItems } from '../../hooks/useDrawerMenuItems';
import styles from './MainLayout.module.css';

const MainLayoutContent = () => {
  const { t } = useTranslation();
  const { isOpen, closeDrawer } = useDrawer();
  const drawerItems = useDrawerMenuItems({ onCloseDrawer: closeDrawer });

  return (
    <DrawerLayout
      isOpen={isOpen}
      onClose={closeDrawer}
      drawerContent={
        <DrawerContent
          items={drawerItems}
          buildVersion={t('drawer.buildVersion', { version: '1.0.0' })}
          onClose={closeDrawer}
        />
      }
    >
      <div className={styles.mainLayout}>
        <Sidebar />
        <main className={styles.content}>
          <Outlet />
        </main>
        <TabBar />
      </div>
    </DrawerLayout>
  );
};

export const MainLayout = () => {
  return (
    <DrawerProvider>
      <MainLayoutContent />
    </DrawerProvider>
  );
};
